import HomeIcon from "@mui/icons-material/Home";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import ArticleIcon from "@mui/icons-material/Article";
import TempleHinduIcon from "@mui/icons-material/TempleHindu";
import InfoIcon from "@mui/icons-material/Info";
import ContactMailIcon from "@mui/icons-material/ContactMail";

import localesKeys from "../locales/localesKeys.json";

export const navItems = (t) => [
  { label: t(localesKeys.NAVIGATION_HOME), path: "/", icon: <HomeIcon /> },
  {
    label: t(localesKeys.NAVIGATION_GRANTH),
    path: "/granth",
    icon: <MenuBookIcon />,
  },
  {
    label: "Articles",
    path: "/article",
    icon: <ArticleIcon />,
  },
  {
    label: t(localesKeys.NAVIGATION_BLOGS),
    path: "/blogs",
    icon: <ArticleIcon />,
  },
  {
    label: t(localesKeys.NAVIGATION_TIRTH),
    path: "/tirth",
    icon: <TempleHinduIcon />,
  },
  {
    label: t(localesKeys.NAVIGATION_ABOUT),
    path: "/about",
    icon: <InfoIcon />,
  },
  {
    label: t(localesKeys.NAVIGATION_CONTACT),
    path: "/contact",
    icon: <ContactMailIcon />,
  },
];
